module.exports = __webpack_public_path__ + "media/images/flags/ne-1b87356bc44824f3b8f4af987bd9b7c3.svg";